import { render, staticRenderFns } from "./TheCourseOverview.vue?vue&type=template&id=740e10a0&scoped=true&"
import script from "./TheCourseOverview.vue?vue&type=script&lang=js&"
export * from "./TheCourseOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e10a0",
  null
  
)

export default component.exports